// Keep the launch contract identical for iframe and separate-window launches.
export const buildGameUrl = (game, item, userId, publicUrl = '') => {
    const params = new URLSearchParams();
    if (item.gameType === 'quiz') {
        params.set('q', item.quizQuestion);
    }
    params.set('env', 'production');
    params.set('tournament_id', item.day);
    params.set('game_id', game);
    params.set('user_id', userId || '');
    return `${publicUrl}/games/${game}/index.html?${params.toString()}`;
};
